// Action Types

export const Types = {
  GET_USER_AGENDA_REQUESTED: 'agenda/GET_USER_AGENDA_REQUESTED',
  GET_USER_AGENDA_SUCCEEDED: 'agenda/GET_USER_AGENDA_SUCCEEDED',
  GET_USER_AGENDA_FAILED: 'agenda/GET_USER_AGENDA_FAILED',
}

// Action Creators

export function getUserAgenda() {
  return {
    type: Types.GET_USER_AGENDA_REQUESTED,
  }
}

// Reducer

const INITIAL_STATE = {
  getUserAgendaIsLoading: false,
  getUserAgendaError: null,
  userAgenda: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_USER_AGENDA_REQUESTED:
      return {
        ...state,
        getUserAgendaIsLoading: true,
      }
    case Types.GET_USER_AGENDA_SUCCEEDED:
      return {
        ...state,
        getUserAgendaIsLoading: false,
        getUserAgendaError: null,
        userAgenda: action.payload,
      }
    case Types.GET_USER_AGENDA_FAILED:
      return {
        ...state,
        getUserAgendaIsLoading: false,
        getUserAgendaError: action.payload,
        userAgenda: null,
      }

    default:
      return state
  }
}
